core.directive('actionInProgress', ['$timeout',
        function($timeout) {
            var definition = {
                compile: function (elem) {
                    elem.append('<md-progress-circular ng-show="showActionInProgress" md-diameter="20px" style="position: absolute; left: 50%; top: 50%; margin-left: -10px; margin-top: -10px;"></md-progress-circular>');
                    elem.on('dblclick', function(){
                        return false;
                    });
                    return {
                        pre: function(scope, elm, attrs, ctrl) {

                            scope.$watch(function () {
                                return scope[attrs.hideMask];
                            }, function (newVal) {
                                scope.hideMask = newVal;
                            });

                            scope.$watch(function () {
                                return scope[attrs.actionInProgress];
                            }, function (newVal) {
                                scope.showActionInProgress = newVal;
                                if (newVal) {
                                    elm.attr('disabled', 'disabled');
                                } else {
                                    $timeout(function () {
                                        elm.removeAttr('disabled');
                                    }, 1000);
                                }
                            });
                        }
                    }
                }
            };

            return definition;
        }]
);